/* ============================================================
   TAP TO BREW - Ajax Cart
   ============================================================ */

(function() {
  'use strict';

  var TTBCart = {
    drawer: null,
    overlay: null,
    itemsContainer: null,
    subtotalEl: null,
    countEls: null,

    init: function() {
      this.drawer = document.getElementById('ttb-cart-drawer');
      this.overlay = document.getElementById('ttb-cart-overlay');
      this.itemsContainer = document.getElementById('ttb-cart-items');
      this.subtotalEl = document.getElementById('ttb-cart-subtotal');
      this.countEls = document.querySelectorAll('.ttb-header__cart-count, #ttb-cart-count');

      this.bindEvents();
    },

    bindEvents: function() {
      var self = this;

      var toggleBtn = document.getElementById('ttb-cart-toggle');
      if (toggleBtn) {
        toggleBtn.addEventListener('click', function(e) {
          e.preventDefault();
          self.open();
        });
      }

      var closeBtn = document.getElementById('ttb-cart-close');
      if (closeBtn) {
        closeBtn.addEventListener('click', function() {
          self.close();
        });
      }

      if (this.overlay) {
        this.overlay.addEventListener('click', function() {
          self.close();
        });
      }

      document.addEventListener('cart:updated', function(e) {
        self.refresh();
        self.open();
      });

      document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape') self.close();
      });
    },

    open: function() {
      if (this.drawer) {
        this.drawer.classList.add('is-open');
        document.body.style.overflow = 'hidden';
      }
      if (this.overlay) {
        this.overlay.classList.add('is-open');
      }
      this.refresh();
    },

    close: function() {
      if (this.drawer) {
        this.drawer.classList.remove('is-open');
        document.body.style.overflow = '';
      }
      if (this.overlay) {
        this.overlay.classList.remove('is-open');
      }
    },

    refresh: function() {
      var self = this;
      fetch('/cart.js', { credentials: 'same-origin' })
        .then(function(r) { return r.json(); })
        .then(function(cart) { self.render(cart); });
    },

    render: function(cart) {
      if (this.countEls) {
        this.countEls.forEach(function(el) {
          el.textContent = cart.item_count;
        });
      }

      if (!this.itemsContainer) return;

      if (cart.items.length === 0) {
        this.itemsContainer.innerHTML = '<p class="ttb-cart-drawer__empty">カートは空です</p>';
        if (this.subtotalEl) this.subtotalEl.textContent = '¥0';
        return;
      }

      var html = '';
      cart.items.forEach(function(item) {
        var price = Math.round(item.final_line_price / 100).toLocaleString();
        var imgSrc = item.image ? item.image.replace(/(\.[^.]+)$/, '_200x$1') : '';
        html += '<div class="ttb-cart-drawer__item" data-key="' + item.key + '">';
        html += '  <div class="ttb-cart-drawer__item-img">';
        if (imgSrc) html += '    <img src="' + imgSrc + '" alt="' + item.title + '" loading="lazy">';
        html += '  </div>';
        html += '  <div class="ttb-cart-drawer__item-info">';
        html += '    <div class="ttb-cart-drawer__item-title">' + item.product_title + '</div>';
        if (item.variant_title) {
          html += '    <div class="ttb-cart-drawer__item-variant">' + item.variant_title + '</div>';
        }
        html += '    <div class="ttb-cart-drawer__item-qty">';
        html += '      <button class="ttb-cart-drawer__qty-btn" data-action="minus" data-key="' + item.key + '">-</button>';
        html += '      <span>' + item.quantity + '</span>';
        html += '      <button class="ttb-cart-drawer__qty-btn" data-action="plus" data-key="' + item.key + '">+</button>';
        html += '    </div>';
        html += '  </div>';
        html += '  <div class="ttb-cart-drawer__item-price">&yen;' + price + '</div>';
        html += '  <button class="ttb-cart-drawer__remove" data-key="' + item.key + '" aria-label="削除">&times;</button>';
        html += '</div>';
      });

      this.itemsContainer.innerHTML = html;

      if (this.subtotalEl) {
        this.subtotalEl.textContent = '¥' + Math.round(cart.total_price / 100).toLocaleString();
      }

      this.bindItemEvents();
    },

    bindItemEvents: function() {
      var self = this;

      this.itemsContainer.querySelectorAll('.ttb-cart-drawer__qty-btn').forEach(function(btn) {
        btn.addEventListener('click', function() {
          var key = this.getAttribute('data-key');
          var action = this.getAttribute('data-action');
          var itemEl = this.closest('.ttb-cart-drawer__item');
          var currentQty = parseInt(itemEl.querySelector('.ttb-cart-drawer__item-qty span').textContent);
          var newQty = action === 'plus' ? currentQty + 1 : currentQty - 1;
          if (newQty < 0) newQty = 0;
          self.updateItem(key, newQty);
        });
      });

      this.itemsContainer.querySelectorAll('.ttb-cart-drawer__remove').forEach(function(btn) {
        btn.addEventListener('click', function() {
          var key = this.getAttribute('data-key');
          self.updateItem(key, 0);
        });
      });
    },

    updateItem: function(key, quantity) {
      var self = this;
      fetch('/cart/change.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: quantity })
      })
        .then(function(r) { return r.json(); })
        .then(function(cart) { self.render(cart); });
    }
  };

  /* --- Public API --- */
  window.TTBCart = {
    addToCart: function(variantId, quantity) {
      quantity = quantity || 1;
      return fetch('/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: quantity }] })
      })
        .then(function(r) {
          if (!r.ok) throw new Error('Cart add failed');
          return r.json();
        })
        .then(function(data) {
          if (typeof gtag === 'function') {
            gtag('event', 'add_to_cart', {
              product_id: variantId,
              quantity: quantity
            });
          }
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: data }));
          return data;
        });
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() { TTBCart.init(); });
  } else {
    TTBCart.init();
  }
})();
